(() => {
  const frame=document.querySelector('iframe.mncs-frame[data-mn-site-shell="embedded"]');
  if(!frame)return;
  let pending=false,viewportPending=false,contentHeight=0,lastWidth=window.innerWidth;
  const mobile=()=>window.innerWidth<=760;
  const reportViewport=()=>{
    viewportPending=false;
    if(!mobile())return;
    let origin;try{origin=new URL(frame.src).origin;}catch{return;}
    const rect=frame.getBoundingClientRect(),viewport=window.visualViewport;
    const viewportTop=viewport?.offsetTop||0,height=viewport?.height||window.innerHeight;
    const header=document.querySelector('.shopify-section-group-header-group')?.getBoundingClientRect();
    const headerBottom=header&&header.top<=viewportTop+1&&header.bottom<height*.5?header.bottom:viewportTop;
    const top=Math.max(0,Math.max(viewportTop,headerBottom)-rect.top+8);
    const bottom=Math.max(top,Math.min(rect.height||contentHeight||1120,viewportTop+height-rect.top-8));
    frame.contentWindow?.postMessage?.({type:'mn:customizer:viewport',version:1,top,bottom,visible:rect.top<viewportTop+height-100&&(rect.bottom??rect.top+(rect.height||contentHeight||1120))>Math.max(viewportTop,headerBottom)+120,keyboard:window.innerHeight-height>140},origin);
  };
  const scheduleViewport=()=>{if(!viewportPending){viewportPending=true;window.requestAnimationFrame(reportViewport);}};
  const setHeight=height=>{
    const value=Math.round(height)+'px';
    frame.style.setProperty?.('--mncs-frame-height',value);
    if(frame.style.height!==value)frame.style.height=value;
  };
  const fit=()=>{
    pending=false;
    if(mobile()){setHeight(contentHeight||1120);reportViewport();return;}
    const landing=!!frame.closest?.('.mn-ad-designer');
    const offset=Math.max(0,frame.getBoundingClientRect().top+(window.scrollY||0));
    setHeight(landing?900:Math.max(480,Math.round(window.innerHeight-offset)));
  };
  const schedule=()=>{if(!pending){pending=true;window.requestAnimationFrame(fit);}};
  const scrollToOptions=offset=>{
    const header=document.querySelector('.shopify-section-group-header-group');
    const margin=header?.getBoundingClientRect().height||64;
    const top=frame.getBoundingClientRect().top+(window.scrollY||0)+offset-margin-12;
    if(Math.abs(Math.max(0,top)-(window.scrollY||0))<48)return;
    window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  };
  window.addEventListener('message',event=>{
    const data=event.data;
    if(event.source!==frame.contentWindow||data?.version!==1||!mobile())return;
    let origin;try{origin=new URL(frame.src).origin;}catch{return;}
    if(event.origin!==origin)return;
    if(data.type==='mn:customizer:layout'){
      if(!Number.isFinite(data.height)||data.height<100||data.height>20000)return;
      contentHeight=data.height;fit();
      if(data.scrollIntent==='step'&&Number.isFinite(data.top)&&data.top>=0&&data.top<=data.height){
        scrollToOptions(data.top);
      }
    }else if(data.type==='mn:customizer:begun'){
      window.requestAnimationFrame(()=>scrollToOptions(0));
    }
  });
  window.addEventListener('resize',()=>{
    if(window.innerWidth!==lastWidth){contentHeight=0;lastWidth=window.innerWidth;}
    schedule();
  },{passive:true});
  window.addEventListener('pageshow',schedule);
  window.addEventListener('scroll',scheduleViewport,{passive:true});
  window.visualViewport?.addEventListener('resize',scheduleViewport,{passive:true});
  window.visualViewport?.addEventListener('scroll',scheduleViewport,{passive:true});
  frame.addEventListener('load',schedule);
  if(typeof ResizeObserver!=='undefined'){
    const observer=new ResizeObserver(schedule);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(section=>observer.observe(section));
  }
  document.fonts?.ready.then(schedule);
  fit();
})();
